import { useQuery } from '@tanstack/react-query';
import { queryFn } from './queryFn';

export const getQueryKey = (companyId: string): [string, string] => [
  'NARRATIVE_VALUATOR',
  companyId,
];

export const useNarrativeValuationCompany = (companyId: string) => {
  return useQuery({
    enabled: !!companyId,
    queryFn,
    queryKey: getQueryKey(companyId),
    retry: 1,
    staleTime: 3600000,
  });
};
